import { CoachService } from '@modules/coach/coach-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';

export class CoachField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/coach',
      Permissions.values.coachRead,
      CoachService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.id,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/coach',
      Permissions.values.coachRead,
      CoachService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.id,
        };
      },
      options,
    );
  }
}
